import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

interface Test {
    isLoading: boolean;
    value: DiscontinuedProductToast;
}

export interface DiscontinuedProductToast {
    isShowToast: boolean;
    toastMessage: string;
}

const initialDiscontinuedProductToastState: Test = {
    isLoading: false,
    value: {
        isShowToast: false,
        toastMessage: "",
    },
};

const reducer = {
    "Data/DiscontinuedProductToast/DiscontinuedProductShowToast": (
        draft: Draft<Test>,
        action: { discontinuedProductToast: DiscontinuedProductToast },
    ) => {
        draft.value = action.discontinuedProductToast;
    },
};

export default createTypedReducerWithImmer(initialDiscontinuedProductToastState, reducer);
